<template>
    <div>
        <TreeTable :value="props.treeTableValue" v-model:selectionKeys="selectedTree">
            <template #empty>No {{ label }} available</template>
            <Column :expander="true" field="id" header="ID" />
            <Column field="name" header="NAME" style="width: 25%" />
            <Column field="childCount" :header="childCountHeader" style="width: 12%" />
            <!-- Department Column only For Themes Entity-->
            <Column v-if="props.entity == 'Theme'" field="department_id" header="DEPARMENT" style="width: 20%">
                <template #body="slotProps">
                    <div>
                        {{ slotProps.body ?? 'No Department set' }}
                    </div>
                </template>
            </Column>
            <Column v-if="props.entity === 'Department'" header="Users" style="width: 12%">
                <template #body="slotProps">

                    <Button
                        v-if="authStore.hasPermission(UserPermission.READ_USER_DEPARTMENT)"
                        icon="pi pi-user"
                        :label="slotProps.node.data.users_count.toString()"
                        rounded
                        outlined
                        aria-label="Display Users"
                        severity="help"
                        v-tooltip="`Display Users for ${slotProps.node.data.name}`"
                        @click="showUserFor(slotProps.node.data.id)"
                        :disabled="slotProps.node.data.users_count === 0"
                        :loading="loadingUsers === slotProps.node.data.id"
                    />
                </template>
            </Column>
            <Column v-if="props.entity === 'Department'" header="Manager" style="width: 12%">
                <template #body="slotProps">
                    <Button
                        v-if="authStore.hasPermission(UserPermission.APPOINT_AS_MANAGER)"
                        icon="pi pi-user-edit"
                        :label="(slotProps.node.data.managers?.length || 0).toString()"
                        rounded
                        outlined
                        aria-label="Manage Manager"
                        severity="info"
                        v-tooltip="`Manage Manager for ${slotProps.node.data.name}`"
                        @click="manageManagerAction(slotProps.node)"
                    />
                </template>
            </Column>
            <Column field="actions" header="ACTIONS" style="width: 12%">
                <template #body="slotProps">
                    <Button v-if="authStore.hasPermission(writePermission)" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editEntity(slotProps.node)" />
                    <Button
                        v-if="authStore.hasPermission(deletePermission)"
                        icon="pi pi-trash"
                        class="p-button-rounded p-button-danger"
                        @click="confirmRequest({ id: slotProps.node.key }, deleteEntity)"
                        :disabled="checkDeleteValidity(slotProps.node)"
                    />
                </template>
            </Column>

            <Column v-if="props.entity === 'Theme'" header="VISIBILITY">
                <template #body="slotProps">
                    <InputSwitch
                    v-if="authStore.hasPermission(writePermission)"
                    :modelValue="slotProps.node.data.visibility"
                     @update:modelValue="val => themeStore.toggleThemeVisibility(slotProps.node.key, val)"
                    />
                </template>
            </Column>

        </TreeTable>
    </div>

    <Dialog
        v-model:visible="usersListVisible"
        :style="{ width: '850px' }"
        header="Department's Users"
        :modal="true"
        class="p-fluid dialog-header"
        @hide="loadingUsers = false"
    >

        <DataTable
            selectionMode="single"
            :value="departmentUsers"
            :paginator="true"
            :rows="10"
            dataKey="id"
            :totalRecords="departmentUsers.length"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport  FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries "
        >
            <Column field="id" header="Id" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
            <Column field="email" header="Email" />
        </DataTable>
    </Dialog>
</template>

<script setup>
import { ref, defineEmits, defineProps, computed } from 'vue';
import { authStore , themeStore } from '../../../store/global-stores';
import { UserPermission } from '../../../modules/permission/enum';
import { checkDeleteValidity } from '../utils';
import { useConfirmRemove } from '../../../composables/ConfirmComposable';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';

const props = defineProps({
    entity: {
        type: String,
    },
    treeTableValue: {
        type: Array,
    },
});

const loadingUsers = ref(null)

const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

const departmentUsers = ref([])
const usersListVisible = ref(false)

const { confirmRequest } = useConfirmRemove();
const selectedTree = ref(null);

//emit
const emit = defineEmits(['editOperation', 'deleteOperation', 'manageManager']);

const label = computed(() => {
    return props.entity ?? 'Entity';
});

const writePermission = computed(() => {
    const permissionString = 'WRITE_' + label.value?.toUpperCase();
    return UserPermission[permissionString];
});

const deletePermission = computed(() => {
    const permissionString = 'DELETE_' + label.value?.toUpperCase();
    return UserPermission[permissionString];
});

const childCountHeader = computed(() => {
    return label.value ? 'SUB ' + (label.value + 's').toUpperCase() : 'Child Count';
});

const editEntity = (data) => {
    emit('editOperation', data);
};

const deleteEntity = (data) => {
    emit('deleteOperation', data);
};

const manageManagerAction = (data) => {
    emit('manageManager', data);
};

function showUserFor(departmentId) {
    loadingUsers.value = departmentId
    //groupStore.fetchGroupUsers(groupId),
    console.log('Department id:', departmentId)

    departmentUsers.value = []

    //  /v2/admin/departments/{departmentId}/users
    authApi.get(`/v2/admin/departments/${departmentId}/users`, {
        params: {
            companyId: company_id.value,
            direct_only: true,
        },
    }).then((response) => {
        console.log('response', response)

        if (response.statusCode === 200) {
            departmentUsers.value = response.data
            usersListVisible.value = true
        }
    }).catch(() => {
        showToast({},  'Failed to fetch users');
    })
}

</script>
